(() => {
  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initContentToggles = (root) => {
    root.querySelectorAll('[data-coming-up-content]').forEach((wrap) => {
      const content = wrap.querySelector('.coming-up__content');
      const button = wrap.querySelector('.coming-up__read-more');
      const label = wrap.querySelector('.coming-up__read-more-label');
      if (!content || !button || !label) return;

      const syncOverflow = () => {
        if (content.classList.contains('is-expanded')) return;
        content.classList.add('is-clamped');
        const overflows = content.scrollHeight > content.clientHeight + 1;
        button.hidden = !overflows;
        if (!overflows) {
          content.classList.remove('is-clamped');
        }
      };

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const expanded = content.classList.toggle('is-expanded');
        content.classList.toggle('is-clamped', !expanded);
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        label.textContent = expanded
          ? label.dataset.labelLess || 'Minder tonen'
          : label.dataset.labelMore || 'Lees meer';
        if (!expanded) syncOverflow();
      });

      syncOverflow();
      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(syncOverflow);
        observer.observe(content);
      }
    });
  };

  const initSlider = (root) => {
    const track = root.querySelector('[data-coming-up-track]');
    const prev = root.querySelector('[data-coming-up-prev]');
    const next = root.querySelector('[data-coming-up-next]');
    if (!track || !prev || !next) return;

    const getStep = () => {
      const item = track.querySelector('.coming-up__item');
      if (!item) return track.clientWidth * 0.8;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return item.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
      root.classList.toggle('coming-up__slider--scrollable', maxScroll > 2);
    };

    const scrollByDir = (dir) => {
      track.scrollBy({
        left: dir * getStep(),
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      });
    };

    prev.addEventListener('click', () => scrollByDir(-1));
    next.addEventListener('click', () => scrollByDir(1));
    track.addEventListener('scroll', updateButtons, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(updateButtons);
      resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', updateButtons);
    }

    updateButtons();
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-coming-up]').forEach((root) => {
      if (root.dataset.comingUpReady === 'true') return;
      root.dataset.comingUpReady = 'true';
      initContentToggles(root);
      initSlider(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
